export default __webpack_public_path__ + "static/media/germany.0ec85121.svg";